var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/AllFolders.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AllFolders = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M11 3.91421C11 3.02331 12.0771 2.57714 12.7071 3.20711L20.4142 10.9142C20.7893 11.2893 21 11.798 21 12.3284V20C21 20.5523 20.5523 21 20 21H12C11.4477 21 11 20.5523 11 20V3.91421Z",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "2",
    height: "18",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    x: "7",
    y: "3",
    width: "2",
    height: "18",
    rx: "1",
    fill: color
  })]
});